package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.repository.AuthRepository
import fr.manyverse.app.domain.repository.SignedUrlCacheRepository

class SignOutUseCase(
    private val authRepository: AuthRepository,
    private val signedUrlCacheRepository: SignedUrlCacheRepository
) {

    suspend operator fun invoke(): Result<Unit> {
        return authRepository.signOut().also {
            // Clear signed URL cache on logout
            signedUrlCacheRepository.clear()
        }
    }
}
